import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Bubble } from "./Bubble.js";
import { QuickReplies } from "./QuickReplies.js";
import { TypingIndicator } from "./TypingIndicator.js";
export function MessageList({ messages, isTyping, showInitialReplies, quickReplies, ctaSlot, logoUrl, brand, onQuickReply, }) {
    const containerRef = useRef(null);
    useEffect(() => {
        const el = containerRef.current;
        if (el)
            el.scrollTop = el.scrollHeight;
    }, [messages, isTyping]);
    return (_jsxs("div", { ref: containerRef, className: "flex-1 overflow-y-auto px-[14px] py-[14px] space-y-[10px] [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-ink-200", children: [messages.map((msg) => (_jsx(Bubble, { role: msg.role, content: msg.content, isStreaming: msg.isStreaming, logoUrl: logoUrl, brand: brand }, msg.id))), showInitialReplies && messages.length > 0 && quickReplies && (_jsx(QuickReplies, { options: quickReplies, onSelect: onQuickReply })), isTyping && _jsx(TypingIndicator, { logoUrl: logoUrl, brand: brand }), ctaSlot] }));
}
//# sourceMappingURL=MessageList.js.map